import React from 'react';

import { SummarySegment, SummarySegmentProps } from 'retired/SummaryCard/SummarySegment';
import { PrimaryButton } from 'retired/PrimaryButton';

interface SummaryCardButtonProps extends SummarySegmentProps {
  onClick: () => void;
}

export const SummaryCardButton = ({ title, onClick, last, ...props }: SummaryCardButtonProps) => (
  <SummarySegment
    {...props}
    last={last}
    content={
      <div
        style={{
          marginTop: 12,
          marginBottom: last ? 0 : 12,
        }}
      >
        <PrimaryButton variant="contained" fullWidth onClick={onClick}>
          {title}
        </PrimaryButton>
      </div>
    }
  />
);
